// extracted by mini-css-extract-plugin
export default {"path":"Path_path__zDI7W"};